import { RouterProvider, createBrowserRouter, Navigate } from "react-router-dom";
import { useRef } from "react";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";
import Login from "../components/user/Login";
import Logout from "../components/user/Logout";
import Dashboard from "../components/books/Book";
import AddBook from "../components/books/AddBook";
import Transaction from "../components/transactions/Transaction";
import AddTransaction from "../components/transactions/AddTransaction";
import ImportTransaction from "../components/transactions/ImportTransaction";
import Category from "../components/categories/Category";
import AddCategory from "../components/categories/AddCategory";
import Member from "../components/members/Member";
import AddMember from "../components/members/AddMember";
import Register from "../components/user/Register";
import Statistic from "../components/statistics/Statistic";
import About from "../components/books/About";
import Profile from "../components/profile/Profile";
import Reset from "../components/user/Reset";
import Periode from "../components/books/Periode";
import { elements } from "chart.js";
import Debt from "../components/debts/Debt";
import Pocket from "../components/pockets/Pocket";

const Routes = () => {
    const routerRef = useRef(null);

    // Define public routes accessible to all users
    const routesForPublic = [
        {
            path: "/service",
            element: <div>Service Page</div>,
        },
        {
            path: "/about-us",
            element: <div>About Us</div>,
        },
    ];

    // Define routes accessible only to authenticated users
    const routesForAuthenticatedOnly = [
        {
            path: "/",
            element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
            children: [
                {
                    path: "/",
                    element: <><Dashboard /></>,
                },
                {
                    path: "/profile",
                    element: <><Profile /></>,
                },
                {
                    path: "/book",
                    element: <><About /></>,
                },
                {
                    path: "/book/add",
                    element: <><AddBook /></>,
                },
                {
                    path: "/pocket",
                    element: <><Pocket /></>
                },
                {
                    path: "/debt",
                    element: <><Debt /></>,
                },
                {
                    path: "/statistics",
                    element: <><Statistic /></>,
                },
                {
                    path: "members",
                    element: <><Member /></>,
                },
                {
                    path: "member/add",
                    element: <><AddMember /></>,
                },
                {
                    path: "/categories",
                    element: <><Category /></>,
                },
                {
                    path: "/category/add",
                    element: <><AddCategory /></>,
                },
                {
                    path: "/periode",
                    element: <Periode/>,
                },
                {
                    path: "/transactions",
                    element: <><Transaction /></>,
                },
                {
                    path: "/transaction/add",
                    element: <><AddTransaction /></>,
                },
                {
                    path: "/book/import",
                    element: <><ImportTransaction /></>,
                },
                {
                    path: "/profile",
                    element: <div>User Profile</div>,
                },
                {
                    path: "/logout",
                    element: <Logout />,
                },
            ],
        },
    ];

    // Define routes accessible only to non-authenticated users
    // Dibungkus PublicRoute: jika user sudah login, akan di-redirect ke "/".
    const routesForNotAuthenticatedOnly = [
        {
            element: <PublicRoute />,
            children: [
                {
                    path: "/register",
                    element: <Register />,
                },
                {
                    path: "/login",
                    element: <Login />,
                },
                {
                    path: "/reset-password",
                    element: <Reset />,
                },
            ],
        },
    ];

    // Router dibuat SEKALI (stabil) agar tidak di-recreate saat token berubah.
    // Guard auth (ProtectedRoute / PublicRoute) yang menangani redirect.
    if (!routerRef.current) {
        routerRef.current = createBrowserRouter([
            ...routesForPublic,
            ...routesForAuthenticatedOnly,
            ...routesForNotAuthenticatedOnly,
            // Fallback: rute tidak dikenal -> arahkan ke halaman utama
            // (ProtectedRoute akan redirect ke /login bila belum auth).
            { path: "*", element: <Navigate to="/" replace /> },
        ]);
    }

    // Provide the router configuration using RouterProvider
    return <RouterProvider router={routerRef.current} />;
};

export default Routes;